module.exports = __webpack_public_path__ + "img/symbol_0.1883be4e.png";